import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaNoWriMo",
  "description": "",
  "published": "2006-10-29T00:00:00.000Z",
  "redirect_from": ["/blog/nanowrimo/swizec/376"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "www.nanowrimo.org"
      }}>{`NaNoWriMo`}</a>{` is fast upon us with October coming to an end. It will be a hectic month of quick thinking and even quicker typing, many a caffeine will be consumed and ideas will flourish. In a word, fun.`}</p>
    <p>{`The goal, as you may know, is to write an entire novel, or at least 50k words of it, in a single month. The task is not easy but it proved last year to be feasible as I came out with just over 55k words. The novel wasn't finished and I never got aroudn to finishing it nor to publishing. This year I have set a personal goal of 90k words which will be achieved by writing 3000 words a day, also feasible. But rather than writing a novel I will be writing a series of intraconnected novelas, which will in the end probably come out looking like chapters of a novel. On top of that, I have firmly decided to do everything in my power to get this work of fiction published and fulfill my long term dream of being a writer, whatever that may mean.`}</p>
    <p>{`As you have probably noticed in the last news post there will be no new comic this month, now you know why, but I promise to try my best at making this blog something daily. The idea being that of daily reports on the progress of NaNoWriMo and everything around it. Hopefully it does not turn out boring.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      